import React from 'react'

type AlertVariant = 'success' | 'warning' | 'error' | 'info'

interface AlertProps {
  children: React.ReactNode
  variant?: AlertVariant
  className?: string
}

const variantStyles: Record<AlertVariant, string> = {
  success: 'bg-success-light border-success text-success',
  warning: 'bg-warning-light border-warning text-warning',
  error: 'bg-error-light border-error text-error',
  info: 'bg-info-light border-info text-info',
}

export const Alert: React.FC<AlertProps> = ({
  children,
  variant = 'error',
  className = '',
}) => {
  return (
    <div className={`
      rounded border px-4 py-3 text-sm
      ${variantStyles[variant]}
      ${className}
    `}>
      {children}
    </div>
  )
}
